import {
  Button,
  IconText,
  Image,
  Input,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useAddFavouriteCategory from "./useAddFavouriteCategory";

const AddFavouriteCategory = ({refetch, favouriteCategoryState, handleModal,setFvouriteCategoryState}) => {
  const { formik,imageUploadState, getFieldError, handleImageChange } = useAddFavouriteCategory({
   refetch,
    favouriteCategoryState,
    handleModal,
    setFvouriteCategoryState
  });
  return (
    <div>
      <Input
        label={"Name"}
        type="text"
        id="name"
        name="name"
        className={`pro-input lg ${getFieldError("name") && " error"}`}
        {...formik.getFieldProps("name")}
        // onChange={(event) => capitalizeOnSpace(event, formik.setFieldValue)}
        error={getFieldError("name")}
        errorMessage={getFieldError("name")}
      />
      <div className="input-wrap pro-mb-4 ">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Image
        </label>
        <div className="input-drag">
          <input
            type="file"
            accept=".jpeg,.jpg , .png "
            className={`pro-input ${
              formik?.errors?.image && formik?.touched?.image && " error"
            }`}
            id="image"
            onBlur={formik?.handleBlur("image")}
            onChange={(e) => handleImageChange(e, "image")}
          />
          <span className="input-drag-box">
            <IconText
              title={
                imageUploadState?.imageLoading
                  ? "Uploading..."
                  : formik?.values?.image !== ""
                  ? formik?.values?.image?.split("/").pop()
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {formik?.touched?.image && formik?.errors?.image && (
            <span className="error-text">{formik?.errors?.image}</span>
          )}
        </div>
        <div className={`col-2 pro-my-2`}>
          <div className={``}>
            <Image
              width={100}
              height={100}
              src={favouriteCategoryState?.imageFile??""}
              alt={`image - 01`}
            />
          </div>
        </div>
      </div>
      <div className="input-wrap pro-mb-4 pro-rtl">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          ( صورة ) Image
        </label>
        <div className="input-drag">
          <input
            type="file"
            accept=".jpeg,.jpg , .png "
            className={`pro-input ${
              formik?.errors?.alias_image &&
              formik?.touched?.alias_image &&
              " error"
            }`}
            id="image"
            onBlur={formik?.handleBlur("alias_image")}
            onChange={(e) => handleImageChange(e, "alias_image")}
          />
          <span className="input-drag-box">
            <IconText
              title={
                imageUploadState?.imageAliasLoading
                  ? "...Uploading"
                  : formik?.values?.alias_image !== ""
                  ? formik?.values?.alias_image?.split("/").pop()
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {formik?.touched?.alias_image && formik?.errors?.alias_image && (
            <span className="error-text">{formik?.errors?.alias_image}</span>
          )}
        </div>
        <div className={`col-2 pro-my-2`}>
          <div className={``}>
            <Image
              width={100}
              height={100}
              src={favouriteCategoryState?.imageAliasFile??""}
              alt={`image - 01`}
            />
          </div>
        </div>
      </div>
      <div
        className={`col-12 pro-d-flex pro-justify-end  offcanvas-footer-sticky-btn `}
      >
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleModal}
        >
          Cancel
        </Button>

        <Button
          className={`pro-btn-primary lg pro-ms-3 ${
            formik?.isSubmitting ? "loading pro-pnt-none" : ""
          }`}
          type="submit"
          onClick={formik.handleSubmit}
        >
         Submit
        </Button>
      </div>
    </div>
  );
};

export default AddFavouriteCategory;
